var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSight({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.447 16.523a3.333 3.333 0 00.678-2.011c0-1.907-1.626-3.458-3.625-3.458s-3.625 1.551-3.625 3.458c0 1.907 1.626 3.458 3.625 3.458.786 0 1.513-.24 2.108-.646l2.632 2.51c.116.11.267.166.42.166a.607.607 0 00.42-.166.548.548 0 000-.8l-2.633-2.511zm-5.384-2.011c0-1.282 1.093-2.325 2.437-2.325 1.344 0 2.437 1.043 2.437 2.325 0 1.282-1.093 2.325-2.437 2.325-1.344 0-2.437-1.043-2.437-2.325zm11.859.28c-.79 1.32-1.901 2.409-3.304 3.237a.61.61 0 01-.817-.184.551.551 0 01.193-.78c1.13-.667 2.044-1.525 2.72-2.553-1.631-2.468-4.744-3.988-8.214-3.988-3.47 0-6.583 1.52-8.214 3.989 2.243 3.419 6.648 4.398 10.096 3.835a.592.592 0 01.686.462.57.57 0 01-.485.654c-.684.112-1.379.167-2.073.167a12.61 12.61 0 01-4.433-.79c-2.179-.825-3.907-2.224-4.999-4.048a.544.544 0 010-.562c.92-1.537 2.32-2.795 4.05-3.639 1.611-.785 3.469-1.2 5.372-1.2s3.76.415 5.371 1.2c1.73.844 3.131 2.102 4.05 3.64a.544.544 0 010 .56zM11.906 7.455V4.566A.58.58 0 0112.5 4a.58.58 0 01.594.566v2.888a.58.58 0 01-.594.567.58.58 0 01-.594-.567zm3.78.663l1.513-2.501a.61.61 0 01.811-.208.552.552 0 01.217.774l-1.514 2.501a.613.613 0 01-.811.207.552.552 0 01-.217-.773zM6.772 6.182a.552.552 0 01.217-.774.61.61 0 01.811.208l1.514 2.5a.552.552 0 01-.217.774.613.613 0 01-.812-.207L6.773 6.182z"
  })));
}

export default SvgSight;